import { createInjectionKey as n } from "../../_utils/vue/create-injection-key.js";
const i = n("n-loading-bar"), a = n("n-loading-bar-api");
export {
  a as loadingBarApiInjectionKey,
  i as loadingBarProviderInjectionKey
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/loading-bar/src/context.js
// module id = 488
// module chunks = 67